import React, { useState } from 'react';
import { AddButton } from '../buttons/Buttons';
import { isEmpty, equals } from 'ramda';
import clearName from '../../../../utils/clearNames';
import { useDispatch, useSelector } from 'react-redux';
import {
    AddAnimationAction,
    EditNameAnimationAction,
    ActivateAnimation,
    SwipeAnimationsAction,
    AddAnimationPayloadInterface,
} from '../../../../Redux/Actions/Animator/animation.list.action';
import generateId from '../../../../utils/generateId';
import { RootState } from '../../../../Redux/Store/store';
import generateRandomColors from '../../../../utils/generateRandomColors';
import { ActivateSideContextMenuAction } from '../../../../Redux/Actions/Atlas/contextSideMenu.action';
import { ObserverAnim, GLOBAL_EVENT_ANIM } from '../../Observer';
import { ReactSortable } from 'react-sortablejs';
import { css } from 'glamor';

const button_disable = css({
    opacity: 0.2,
});

const AnimationList = () => {
    // States
    const [AddAnimation, setAddAnimation] = useState(false);
    const [EditAnimationName, setEditAnimationName] = useState('0');

    ObserverAnim.on(GLOBAL_EVENT_ANIM.EDIT_ANIM_NAME, (id) => {
        setEditAnimationName(id);
    });

    // Store
    const animation_list = useSelector((store: RootState) => store.AnimationList);
    const atlas_anim = useSelector((store: RootState) => store.atlasAnim);
    const dispatch = useDispatch();

    // Local vars
    const actualBoxColor = generateRandomColors();

    const handleClickAddAnimation = () => {
        setAddAnimation(true);
    };

    // Add new animation
    const handleKeyPressAddAnimation = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            saveText(event.currentTarget.value);
        }
    };
    const handleInputBlurAddAnimation = (event: React.FocusEvent<HTMLInputElement>) => {
        const name_trimmed = event.currentTarget.value.trim().trimLeft().trimRight().trimEnd();
        saveText(name_trimmed);
        setAddAnimation(false);
    };
    // Edit animation name
    const handleKeyPressEditName = (id: string, event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            editText({ id, name: event.currentTarget.value });
        }
    };
    const handleInputBlurEditName = (id: string, event: React.FocusEvent<HTMLInputElement>) => {
        const name_trimmed = event.currentTarget.value.trim().trimLeft().trimRight().trimEnd();
        setEditAnimationName('0');
        editText({ name: name_trimmed, id });
    };

    // Save Add and Edit image
    const saveText = (name_in: string) => {
        if (!isEmpty(name_in)) {
            const id = `anim_${generateId()}`;
            const name = clearName(name_in);
            dispatch(
                AddAnimationAction({
                    id,
                    name,
                    color: actualBoxColor,
                    play: false,
                    key_controls: {
                        repeat: -1,
                        frame_rate: 12,
                        yoyo: false,
                    },
                    frames: [],
                })
            );
            setAddAnimation(false);
        } else {
            console.log('Está vacío');
        }
    };

    const editText = (options: { name: string; id: string }) => {
        if (!isEmpty(options.name)) {
            dispatch(
                EditNameAnimationAction({
                    id: options.id,
                    name: clearName(options.name),
                })
            );
            setEditAnimationName('0');
        }
    };

    return (
        <React.Fragment>
            <div className="animate_tool-container">
                <div className="my-2 w-100 d-flex justify-content-between align-items-center">
                    <h3 className="text-color-primary">Animations</h3>
                    <span className="mr-3">
                        {isEmpty(atlas_anim.image) || isEmpty(atlas_anim.json) ? (
                            <AddButton
                                className={button_disable}
                                onClick={() => {
                                    ObserverAnim.emit(
                                        GLOBAL_EVENT_ANIM.NOTIFICATION_SYSTEM.WARNING,
                                        'You must import an atlas'
                                    );
                                }}
                            >
                                +
                            </AddButton>
                        ) : (
                            <AddButton onClick={handleClickAddAnimation}>+</AddButton>
                        )}
                    </span>
                </div>
                {AddAnimation && (
                    <div className="ml-3">
                        <div
                            className={`m-0 my-2 animated fadeIn card-image`}
                            style={{ height: '30px' }}
                        >
                            <div className="card-image--image">
                                <div
                                    className="block-color-animate-card"
                                    style={{
                                        width: '30px',
                                        height: '30px',
                                        borderRadius: '5px',
                                        backgroundColor: actualBoxColor,
                                    }}
                                ></div>
                            </div>

                            <div className="w-100 card-image--nameImage">
                                <input
                                    type="text"
                                    className="card-image--nameImage_input"
                                    autoFocus={true}
                                    onFocus={(event) => {
                                        event.target.select();
                                    }}
                                    onKeyDown={handleKeyPressAddAnimation}
                                    onBlur={handleInputBlurAddAnimation}
                                />
                            </div>
                        </div>
                    </div>
                )}

                {/* Estos estilos están heredados del Atlas packer */}
                {/* Esto se repetirá para importar muchas imágenes */}
                <ReactSortable
                    list={animation_list.animations}
                    setList={(newState) => {
                        if (!isEmpty(atlas_anim.image) && !isEmpty(atlas_anim.json)) {
                            if (!equals(newState, animation_list.animations)) {
                                dispatch(
                                    SwipeAnimationsAction(
                                        newState as Array<AddAnimationPayloadInterface>
                                    )
                                );
                            }
                        }
                    }}
                    swap
                >
                    {animation_list.animations.map((animation: any) => (
                        <div
                            className="ml-3"
                            key={animation.id}
                            onContextMenu={(event) => {
                                dispatch(ActivateAnimation({ id: animation.id }));
                                dispatch(
                                    ActivateSideContextMenuAction({
                                        x: event.clientX,
                                        y: event.clientY,
                                        id: animation.id,
                                        active: true,
                                    })
                                );
                            }}
                            onClick={() => {
                                dispatch(ActivateAnimation({ id: animation.id }));
                            }}
                        >
                            <div
                                className={`m-0 my-2 animated fadeIn card-image ${
                                    animation_list.actual_animation === animation.id &&
                                    'card-image-active'
                                }`}
                                style={{ height: '30px' }}
                            >
                                <div className="card-image--image">
                                    <div
                                        className="block-color-animate-card"
                                        style={{
                                            width: '30px',
                                            height: '30px',
                                            borderRadius: '5px',
                                            backgroundColor: animation.color,
                                        }}
                                    ></div>
                                </div>
                                <div className="w-100 card-image--nameImage">
                                    {EditAnimationName === animation.id ? (
                                        <input
                                            type="text"
                                            className="card-image--nameImage_input"
                                            autoFocus={true}
                                            onFocus={(e) => {
                                                e.target.select();
                                            }}
                                            onKeyDown={(e) =>
                                                handleKeyPressEditName(animation.id, e)
                                            }
                                            onBlur={(e) => handleInputBlurEditName(animation.id, e)}
                                        />
                                    ) : (
                                        <span
                                            onDoubleClick={() => setEditAnimationName(animation.id)}
                                        >
                                            {animation.name}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </ReactSortable>
            </div>
        </React.Fragment>
    );
};

export default AnimationList;
